import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import tableLivesCatalog from './tableLiveTemplatesCatalog';

export default {
  attributeName: 'lives',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canModify:true,
  canRemove: true,
  createPath: routes.LIVE_NEW,
  editURL: routes.LIVE_EDIT,
  modifyURL:routes.LIVE_APPS,
  fromCatalogTable: tableLivesCatalog,
  fromCatalogText:'New from template',
  fromCatalogTableMultiple: false,
  emptyMessage: "You don't have Live events yet, click on the +new button to make a new one.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Id of the event.',
      canOrder: true,
      canFilter: true,
      exactWidth:'80px'
    },
    {
      attributeName: 'event_type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Type of Live event.',
      canOrder: true,
      canFilter: true,
      exactWidth:'120px'

    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Name of Live event.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'status_deployment',
      label: 'Status Deploy',
      helpText: 'Status of Deployment.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'deployment_log',
      // width: '10rem',
      exactWidth:'100px',
      small:true,
      colors: {
        not_connected: 'bg-gray',
        ready: 'bg-success',
        starting: 'bg-warning',
        down:'bg-warning',
        up:'bg-success',
        error: 'bg-danger',
      },
      additionalCss:"hide-on-L"
    },
    {
      attributeName: 'deployment_code',
      label: 'Deployment',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Code of Live deployment.',
      canOrder: true,
      canFilter: true,
      exactWidth:'100px'

    },
    {
      attributeName: 'region',
      label: 'Region',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Region of live event.',
      canOrder: true,
      canFilter: false,
      exactWidth:'100px'
    },
    {
      attributeName: 'structure',
      label: 'Cams',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Cameras composition of live event.',
      canOrder: false,
      canFilter: false,
      className:'table__small-text',
      exactWidth:'80px',
      additionalCss:"hide-on-L"
    },

    {
      attributeName: 'status_live',
      label: 'Live',
      helpText: 'Status of Live event.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'live_log',
      // width: '10rem',
      exactWidth:'100px',
      small:true,
      colors: {
        draft: 'bg-info',
        draft_template: 'bg-info',
        yaml_sent:'bg-warning',
        cloud_starting:'bg-warning',
        cloud_started:'bg-success',
        cloud_stopping:'bg-warning',
        cloud_stopped:'bg-warning',
        cloud_pending:'bg-warning',
        cloud_down:'bg-warning',
        ingest_starting:'bg-warning',
        ingest_stopping:'bg-warning',
        ingest_stopped:'bg-warning',
        ingest_started:'bg-success',
        open: 'bg-warning',
        close: 'bg-danger',
        error:'bg-danger',
        not_ready: 'bg-danger',
        ready: 'bg-warning',
        publishing_video: 'bg-success',
        started:'bg-success'
      },
      additionalCss:"hide-on-S"
    },
    {
      attributeName: 'status_cloud',
      label: 'Cloud',
      helpText: 'Status of Cloud event.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'cloud_log',
      // width: '10rem',
      exactWidth:'100px',
      small:true,
      colors: {
        not_connected: 'bg-gray',
        init_start: 'bg-warning',
        starting: 'bg-warning',
        shutting_down:'bg-warning',
        down:'bg-warning',
        stopping: 'bg-warning',
        stopped:'bg-warning',
        pending: 'bg-warning',
        started: 'bg-success',
        up:'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
      },
      additionalCss:"hide-on-S"
    },
    {
      attributeName: 'status_ingest',
      label: 'Ingest',
      helpText: 'Status of Ingest event.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'ingest_log',
      // width: '10rem',
      exactWidth:'100px',
      small:true,
      colors: {
        not_connected: 'bg-gray',
        starting:'bg-warning',
        stopping: 'bg-warning',
        pending:'bg-warning',
        started:'bg-success',
        stopped:'bg-warning',
        enqueued: 'bg-info',
        processing: 'bg-info',
        success: 'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
      },
      additionalCss:"hide-on-S"
    },
    // {
    //   attributeName: 'log',
    //   label: 'Logs',
    //   width: '4rem',
    //   size:'xl',
    //   helpText: 'More information about the Live Event logs.',
    //   type: FormInputTypes.MORE,
    // },
    {
      attributeName: 'agents',
      label: 'Agents',
      width: '4rem',
      size:'xl',
      helpText: 'More information about the Agents connected.',
      type: FormInputTypes.MORE,
      exactWidth:'40px',
      small:true,
      additionalCss:"hide-on-M"

    },
    {
      attributeName: 'created_at',
      label: 'Created At',
      width: '12rem',
      helpText: 'Date of Live event creation.',
      type: FormInputTypes.TIMESTAMP,
      canOrder: true,
      additionalCss:"hide-on-L"
    },
    {
      attributeName: 'logLink',
      label: 'Monitor',
      type: FormInputTypes.LINK,
      icon: IconType.LOG,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      exactWitdh:'100px'
      // helpText: 'Live monitor for this event.',
    },   
  ],
};
